import { useEffect, useRef } from 'react';
import { styled } from '@mui/system';
import Icon from 'app/components/Icon';

const HTag = styled('h2')(({ mb, padding = 0 , fontSize, border, background, fx, bs, link = null, ht = 0}) => ({
  background,
  fontSize:fontSize+'px !important',
  padding:padding,
  marginBottom:mb,
  borderBottom:border ? `1px solid ${border !== '1' ? border : 'rgba(0, 0, 0, 0.1)'}` : null,
  boxShadow: fx || bs ? "0px 2px 5px #e5e5e5" : "none",
  position: fx ? "fixed" : "relative",
  width:fx || ht ? "100%" : null,
}));

const IconBox = styled(Icon)(({ fontSize}) => ({ fontSize: fontSize+'px !important', marginRight:6+(fontSize-17)*2 }));
const CounterBox = styled('span')(({fontSize})=>({ fontSize:(parseFloat(fontSize)-2)+'px !important'}));

export default function Heading({ children, mb = 0, padding=null, icon = null, fontSize = 16, iconSize = null, border = null, counter = 0, onLayout = null, bg=null, fixed = false, bs = false, tag = null, container = null }) {
    let icnSize = iconSize || (parseInt(fontSize)+2);
    if( !counter ) counter = 0;

    if( padding === null || padding === "")
        padding = "14px 20px";

    const ref = useRef();
    useEffect(()=>{ 
        onResize();
        window.addEventListener("resize", ()=>onResize());
        return ()=>window.removeEventListener("resize", ()=>onResize());
    },[]);

    const onResize = () =>{
        if( onLayout )
            onLayout({width: ref?.current?.clientWidth || 0, height: ref?.current?.clientHeight || 0});
    }  

    const content = () =>{
        return <>
            {icon ? <IconBox className="icon" fontSize={icnSize}>{icon}</IconBox> : null}{children}
            {counter > 0 && <CounterBox className="cntr" fontSize={fontSize}>({counter})</CounterBox>}
            {tag && <div>{tag}</div>}
        </>
    }

    return (
        <HTag className="content-heading" ref={ref} mb={mb} padding={padding} fontSize={fontSize} border={border} background={bg} fx={fixed ? 1 : 0} ht={tag ? 1 : 0} bs={bs ? 1 : 0}>
            {container ? container(content()) : content()}
        </HTag>
    );
}